<template>
  <div class="flex justify-center items-center">
    <div class="w-full max-w-lg">
      <form @submit.prevent="submit">
        <div class="px-10 pb-12">
          <h1 class="text-center font-bold text-3xl uppercase">Autentificare</h1>
          <div class="mx-auto mt-6 w-24 border-b-2" />
          <text-input v-model="form.email" :required="true" :errors="$page.errors.email" class="mt-10" label="Email" type="email" autofocus autocapitalize="off" />
          <text-input v-model="form.password" :required="true" :errors="$page.errors.password" class="mt-6" label="Parolă" type="password" />
          <label class="mt-6 select-none flex items-center" for="remember">
            <input id="remember" v-model="form.remember" class="mr-1" type="checkbox">
            <span class="text-sm">Ține-mă minte</span>
          </label>
        </div>
        <div class="px-10 py-4 bg-grey-100 border-grey-200 flex justify-between items-center">
          <loading-button :loading="sending" class="btn-gray" type="submit">Autentificare</loading-button>
        </div>
        <div class="mx-auto mt-6 w-24 border-b-2" />
        <div class="px-10 mt-12">
          Nu aveți cont?
          <inertia-link class="text-gray-700 hover:text-gray-900" :href="route('shop.register')">Apăsați aici pentru a vă înregistra!</inertia-link>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import Logo from '@/Shared/Logo'
import TextInput from '@/Shared/TextInput'

export default {
  metaInfo() {
    return {
      title: 'Autentificare',
      meta: [
        { name: 'robots', content: 'noindex, nofollow, nosnippet, noarchive' },
        { name: 'googlebot', content: 'noindex, nofollow, nosnippet, noarchive' }
      ]
    }
  },
  layout: Layout,
  components: {
    LoadingButton,
    Logo,
    TextInput,
    Layout
  },
  props: {
    errors: Object,
  },
  data() {
    return {
      sending: false,
      form: {
        email: null,
        password: null,
        remember: null,
      },
    }
  },
  methods: {
    submit() {
      this.sending = true
      this.$inertia.post(this.route('shop.login.attempt').url(), {
        email: this.form.email,
        password: this.form.password,
        remember: this.form.remember,
      }).then(() => this.sending = false)
    },
  },
}
</script>
